import { IState } from 'reducers'
import {CityType} from '../../models/CityType'

export const getAppCurrentCity = ({ app }: IState): CityType => app.currentCity
export const getAppUserCity = ({ app }: IState): CityType => app.userCity
export const getAppScrollLockSelector = ({ app }: IState): boolean => app.scrollLock
export const getAppShowEmailConfirmModal = ({ app }: IState): boolean => app.showEmailConfirmModal
